import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import RentalsHub from "@/pages/RentalsHub";
import WestBranch from "@/pages/WestBranch";
import LakeMilton from "@/pages/LakeMilton";
import BoatingClub from "@/pages/BoatingClub";
import Employment from "@/pages/Employment";
import Winterization from "@/pages/Winterization";
import BoatsForSale from "@/pages/BoatsForSale";
import CleanMarina from "@/pages/CleanMarina";
import CustomerPhotos from "@/pages/CustomerPhotos";
import StorageDocking from "@/pages/StorageDocking";
import Supplies from "@/pages/Supplies";
import LakeInformation from "@/pages/LakeInformation";
import RentalRequirements from "@/pages/RentalRequirements";
import Contact from "@/pages/Contact";
import BoatDetail from "@/pages/BoatDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import BookingConfirmation from "@/pages/BookingConfirmation";
import ErrorBoundary from "@/components/ErrorBoundary";
import PaymentHandoff from "@/pages/PaymentHandoff";
import BookingLookup from "@/pages/BookingLookup";
import AccountLogin from "@/pages/AccountLogin";
import AccountRegister from "@/pages/AccountRegister";
import AccountProfile from "@/pages/AccountProfile";
import AccountTrips from "@/pages/AccountTrips";
import AccountForgotPassword from "@/pages/AccountForgotPassword";
import AccountResetPassword from "@/pages/AccountResetPassword";
import { AuthProvider } from "@/hooks/useAuth";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/account/login" element={<ErrorBoundary><AccountLogin /></ErrorBoundary>} />
          <Route path="/account/register" element={<ErrorBoundary><AccountRegister /></ErrorBoundary>} />
          <Route path="/account/forgot-password" element={<ErrorBoundary><AccountForgotPassword /></ErrorBoundary>} />
          <Route path="/account/reset" element={<ErrorBoundary><AccountResetPassword /></ErrorBoundary>} />
          <Route path="/account" element={<ErrorBoundary><AccountProfile /></ErrorBoundary>} />
          <Route path="/account/trips" element={<ErrorBoundary><AccountTrips /></ErrorBoundary>} />
          <Route path="/boat-rentals" element={<RentalsHub />} />
          <Route path="/boating-club" element={<BoatingClub />} />
          <Route path="/employment" element={<Employment />} />
          <Route path="/winterization" element={<Winterization />} />
          <Route path="/boats-for-sale" element={<BoatsForSale />} />
          <Route path="/clean-marina" element={<CleanMarina />} />
          <Route path="/customer-photos" element={<CustomerPhotos />} />
          <Route path="/boat-rentals/west-branch" element={<WestBranch />} />
          <Route path="/boat-rentals/west-branch/boats/:assetId" element={<BoatDetail />} />
          <Route path="/cart" element={<ErrorBoundary><Cart /></ErrorBoundary>} />
          <Route path="/checkout" element={<ErrorBoundary><Checkout /></ErrorBoundary>} />
          <Route path="/booking/payment" element={<ErrorBoundary><PaymentHandoff /></ErrorBoundary>} />
          <Route path="/booking/confirmation" element={<ErrorBoundary><BookingConfirmation /></ErrorBoundary>} />
          <Route path="/booking/lookup" element={<ErrorBoundary><BookingLookup /></ErrorBoundary>} />
          <Route path="/boat-rentals/lake-milton" element={<LakeMilton />} />
          <Route path="/boat-rentals/lake-milton/boats/:assetId" element={<BoatDetail />} />
          <Route path="/storage-and-docking" element={<StorageDocking />} />
          <Route path="/supplies" element={<Supplies />} />
          <Route path="/lake-information" element={<LakeInformation />} />
          <Route path="/rental-requirements" element={<RentalRequirements />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}
